import { certificationActionType } from 'redux/actionsTypes';
import produce from 'immer';
import { IProfileCertificationsObject } from '../../../@types/profile-types';
import mockCertificationData from 'assets/data/profile/certification.json';

const initialData: IProfileCertificationsObject[] = mockCertificationData.data as IProfileCertificationsObject[];

export interface IProfileCertificationsInfo {
    error: boolean;
    data: IProfileCertificationsObject[];
    loading: boolean;
}

interface IprofileCertificationsAction {
    type: string;
    payload: IProfileCertificationsObject[];
}

const initialStateData = {
    error: false,
    data: [initialData[0]],
    loading: false,
};

const reducer = (
    state: IProfileCertificationsInfo = initialStateData,
    action: IprofileCertificationsAction
) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case certificationActionType.PROFILE_CERTIFICATIONS_ERROR:
                draft.error = true;
                draft.data = [];
                draft.loading = false;
                return draft;
            case certificationActionType.PROFILE_CERTIFICATIONS_LOADING:
                draft.error = false;
                draft.data = [initialData[0]];
                draft.loading = true;
                return draft;
            case certificationActionType.PROFILE_CERTIFICATIONS_SUCCESS:
                draft.error = false;
                draft.data = action.payload;
                draft.loading = false;
                return draft;
        }
        return state;
    });
};

export default reducer;
